<div style="flex: 1; min-height: 0">
  <p-tree
    (selectionChange)="selection = getAllActiveMappedValues($event)"
    [filter]="true"
    [loading]="loading"
    [selection]="selection"
    [value]="value"
    [virtualScroll]="true"
    [virtualScrollItemSize]="46"
    filterMode="strict"
    scrollHeight="flex"
    selectionMode="checkbox"></p-tree>
</div>

<div class="mt-2">
  <p-button
    (onClick)="save()"
    [label]="'ACTIONS.SAVE' | translate"
    icon="fal fa-save"
    styleClass="mr-2"
    type="button"></p-button>
  <p-button
    (onClick)="cancel()"
    [label]="'ACTIONS.CANCEL' | translate"
    icon="fal fa-times"
    styleClass="p-button-secondary"
    type="button"></p-button>
</div>
